import SearchIcon from '../../assets/images/svgicons/search.svg';
import InfoIcon from '../../assets/images/svgicons/info.svg';
import {useTranslation} from 'react-i18next';
import {Popover, PopoverContent, PopoverTrigger} from 'alm-react-components';

const Search = (Props: any) => {
  const {t} = useTranslation();
  return (
    <div className="flex gap-4 w-max">
      <label
        htmlFor="default-search"
        className="mb-2 text-sm font-medium text-gray-900 sr-only dark:text-white"
      >
        {t('Search.search')}
      </label>
      <div className="relative lg:w-[396px] xl:w-[396px] md:w-full">
        <div className="absolute inset-y-0 start-0 flex items-center  ms-2">
          <img className="cursor-pointer" src={SearchIcon} alt={''} onClick={Props.onSearchClick} />
        </div>
        <input
          type="search"
          id="default-search"
          className="block w-full py-2 ps-10 font-opensansRegular border border-cardBorder focus:border-cardBorder active:border-cardBorder focus-visible:border-cardBorder outline-none rounded bg-searchBg"
          placeholder={t('Search.search')}
          required
          onChange={e => Props.onhandleSearch(e)}
          onKeyDown={e => Props.onhandleSearch(e)}
        />
      </div>
      <Popover>
        <PopoverTrigger asChild>
          <img className="" src={InfoIcon} alt="" />
        </PopoverTrigger>
        <PopoverContent className="w-60">
          <div className="space-y-2">
            <p className="font-medium leading-none">{t('Library.description')}</p>
          </div>
        </PopoverContent>
      </Popover>
    </div>
  );
};

export default Search;
